import { useEffect, useRef } from 'react';

// Usage: const ref = useFadeInOnScroll(className);
// className: optional, e.g. 'fade-in-left', 'fade-in-right', or default 'fade-in-section'
export default function useFadeInOnScroll(className = 'fade-in-section') {
  const ref = useRef();

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    node.classList.add(className);
    const handleScroll = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          node.classList.add('fade-in-visible');
        }
      });
    };
    const observer = new window.IntersectionObserver(handleScroll, {
      threshold: 0.15
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [className]);

  return ref;
}
